<template>
  <div class="a4page" v-if="!custom_contract_text">
    <!-- ===================== PAGE 1 ===================== -->
    <div class="page">
      <div class="doc-title">عقد اشتراك</div>

      <div class="parties">
        <div class="party-row">
          <span class="party-label">الفريق الأول:</span>
          <span class="fill wide">{{ setting.contract.company_name }}</span>
        </div>
        <div class="party-row">
          رقم قرار الترخيص:
          <span class="fill">{{ setting.contract.license_number }}</span>
          تاريخ القرار:
          <span class="fill">{{ setting.contract.license_date }}</span>
        </div>
        <div class="party-row">
          تخصص الشركة:
          <span class="fill">{{ setting.contract.company_speciality }}</span>
        </div>

        <div class="party-row">
          <span class="party-label">الفريق الثاني: الاسم:</span>
          <span class="fill">{{ account.first_name }}</span>
          بن
          <span class="fill">{{ account.father_name }}</span>
          ووالدته
          <span class="fill">{{ account.mother_name }}</span>
        </div>
        <div class="party-row">
          سنة المواليد:
          <span class="fill date"> </span>/<span class="fill date"> </span
          >/<span class="fill date"> </span>
          القيد:
          <span class="fill"> </span>
          بموجب الهوية الشخصية:
          <span class="fill">{{ account.national_id }}</span>
        </div>

        <div class="party-row">
          صادرة عن أمانة سجل:
          <span class="fill"> </span>
          تاريخ المنح:
          <span class="fill date"> </span>/<span class="fill date"> </span
          >/<span class="fill date"> </span>
        </div>

        <div class="party-row">
          العنوان: المحافظة
          <span class="fill">{{ account.state }}</span>
          المدينة
          <span class="fill">{{ account.city }}</span>
          مكان السكن:
          <span class="fill wide">{{ account.address }}</span>
        </div>

        <div class="party-row">
          عنوان البريد الإلكتروني:
          <span class="fill wide">{{ account.email }}</span>
          رقم التواصل:
          <span class="fill">{{ account.phone }}</span>
        </div>
        <div class="party-row">
          اسم المستخدم:
          <span class="fill">{{ account.username }}</span>
          كلمة المرور:
          <span class="fill">{{ account.password }}</span>
          عنوان IP:
          <span class="fill" v-if="account.private_ip">{{
            account.private_ip.ip_address
          }}</span>
        </div>
      </div>

      <h2 class="section-title">مقدمة العقد</h2>

      <ul class="intro-list">
        <li>
          بما أن الفريق الأول المرخص له بتقديم خدمات الاتصالات بقرار رقم (
          {{ setting.contract.license_number }} ) تاريخ (
          {{ setting.contract.license_date }} ) الصادرة عن الهيئة الناظمة
          للاتصالات والبريد فإن له كامل الصلاحيات والاختصاص
          {{ setting.contract.company_speciality }}.
        </li>
        <li>وبما أن الفريق الثاني يرغب بالاشتراك بخدمة الإنترنت.</li>
      </ul>

      <p>
        <strong
          >فقد اتفق الفريقان وهما بكامل الأهلية الشرعية والقانونية وفق ما
          يلي:</strong
        >
      </p>

      <div class="article">
        <p>
          <span class="article-title">مادة (١):</span> تعتبر مقدمة هذا العقد
          جزءً لا يتجزأ منه وتسري عليه كافة مفاعيله القانونية.
        </p>
      </div>

      <div class="article">
        <p>
          <span class="article-title">مادة (٢):</span> اطلع الفريق الثاني على
          جميع الشروط والأحكام وقانون الاتصالات رقم /١٨/ لعام /٢٠١٠/ النافذ في
          الجمهورية العربية السورية وعلى جميع المعلومات القانونية بما يخص
          الترخيص لتقديم خدمة الاتصالات للطرف الاول وعلى الترخيص الممنوح له
          المذكور في المقدمة أعلاه.
        </p>
      </div>

      <div class="article">
        <p class="article-title">مادة (٣) التزامات المرخص له:</p>
        <p>
          <span class="clause-letter">أ-</span> يلتزم الفريق الأول بتقديم الخدمة
          للمشترك وفق الأحكام والشروط المنصوص عليها في العقد بما يتوافق مع
          معايير الجودة المعتمدة في الهيئة الناظمة للاتصالات والبريد واللائحة
          التنفيذية وقانون /١٨/ لعام /٢٠١٠/.
        </p>
        <p>
          <span class="clause-letter">ب-</span> يلتزم الفريق الأول "المرخص له"
          بتأمين كافة الإجراءات والدعم الفني في حال حدوث أي انقطاع في الخدمة
          بسبب التعديلات أو الصيانة وإعلام الفريق الثاني عن طريق أرقام التواصل
          المحددة في مقدمة العقد أي عطل أدى إلى إيقاف الخدمة بما ذلك حالات القوة
          القاهرة.
        </p>
        <p>
          <span class="clause-letter">ج-</span> يلتزم الفريق الأول بتعويض الفريق
          الثاني في حال حدوث عطل أو انقطاع في الخدمة الممنوحة ناتجة عن الفريق
          الأول بما يتناسب مع مدة العطل في حال كان العطل ناتج عن عوامل وأهلية
          خاصة بها (باستثناء حالات توقف الخدمة للصيانة أو التعديلات أو التوسعات
          التي تتم على الشبكة على أن يتم إعلام الفريق الثاني بمدة معقولة).
        </p>
        <p>
          <span class="clause-letter">د-</span> يلتزم الفريق الأول باتخاذ جميع
          الإجراءات الضامنة لسرية وخصوصية بيانات الفريق الثاني باستثناء بناءً عن
          طلب الجهات المختصة أصولاً أو بطلب رسمي من قبل الهيئة الناظمة للاتصالات
          والبريد.
        </p>
        <p>
          <span class="clause-letter">هـ-</span> يلتزم الفريق الأول بنشر الأسعار
          بشكل واضح على الموقع الإلكتروني أو وسائل التواصل الخاصة بالفريق الأول.
        </p>
        <p>
          <span class="clause-letter">و-</span> يلتزم الفريق الأول بإعلام الفريق
          الثاني عن أي تعديل يطرأ على عنوانه أو بيانات الاتصالات عن طريق أرقام
          التواصل المدون في المقدمة.
        </p>
        <p>
          <span class="clause-letter">ز-</span> يلتزم الفريق الأول بتوفير الية
          واضحة وفعالة تمكن الفريق الثاني من متابعة ومراقبة استهلاكه واستخدامه
          لخدمة الانترنت بما في ذلك الاطلاع على حجم الاستهلاك وسرعة الخدمة ومدة
          الاستخدام وأي حدود أو اي قيود مرتبطة بالباقة التي تم الاشتراك بها،
          وذكر عبر التطبيق الرسمي المعتمد أو من خلال اي وسيلة تقنية معتمدة
          تتيحها الشركة، بما يضمن حق الفريق الثاني في الشفافية والمعرفة.
        </p>
        <p>
          <span class="clause-letter">ح-</span> يلتزم الفريق الأول بتوفير
          واعتماد الية واضحة لاستقبال ومعالجة شكاوي الفريق الثاني المتعلقة
          بالخدمة المقدمة، بما في ذلك تقديم الدعم الفني والمساعدة في حل أي مشاكل
          تقنية أو فنية قد تواجه الفريق الثاني أثناء استخدام الخدمة عن طريق
          تطبيق معتمد أو من خلال اي وسيلة تقنية معتمدة تتيحها الشركة، بما يضمن
          حق الفريق الثاني في الحصول على خدمة فعالة وموثوقة.
        </p>
      </div>

      <div class="article">
        <p class="article-title">مادة (٤) واجبات المشترك:</p>
        <p>
          <span class="clause-letter">أ-</span> يلتزم الفريق الثاني بإعلام
          الفريق الأول "المرخص له" عن أي تعديل يطرأ على عنوانه أو أرقام التواصل
          معه أو البريد الإلكتروني بالطريقة المحددة في مقدمة العقد.
        </p>
        <p>
          <span class="clause-letter">ب-</span> يلتزم الفريق الثاني بعدم استخدام
          أو السماح باستخدام خدمة الإنترنت لأغراض تخل بالأمن والسلامة العامة أو
          الآداب أو بأي صورة مخافة لقانون الاتصالات رقم /١٨/ لعام /٢٠١٠/ أو
          اللائحة التنفيذية الصادرة عن الهيئة الناظمة للاتصالات والبريد وجرائم
          المعلوماتية والأنظمة القانونية المعمول بها في الجمهورية العربية
          السورية.
        </p>
        <p>
          <span class="clause-letter">ت-</span> يلتزم الفريق الثاني بعدم إعادة
          بيع أو توزيع خدمات للإنترنت لأي طرف وأنه يتحمل المسؤولية القانونية
          والمسؤولية المالية الناتجة عن مخالفته ويحق للمرخص له أي الفريق الأول
          اتخاذ كافة الإجراءات الملائمة بما فيها الإلغاء الفوري للخدمة دون أي
          إنذار أو إشعار مسبق.
        </p>
        <p>
          <span class="clause-letter">ث-</span> لا يحق للمشترك التنازل عن الخدمة
          لأي طرف آخر أو أي حق من حقوق الغير، ويتحمل الفريق الثاني بمفرده كافة
          المسؤوليات الناتجة عن هذا التنازل وفقاً لهذا العقد والأنظمة النافذة في
          الهيئة الناظمة للاتصالات والبريد ويحق للمرخص له في الإلغاء الفوري دون
          الرجوع إلى الفريق الثاني ويحق للمرخص له طلب التعويض عن هذه المخالفة أو
          عدم الالتزام أو عند التنازل ولا يحق للفريق الثاني طلب أي تعويض جراء
          الإلغاء الفوري.
        </p>
        <p>
          <span class="clause-letter">ج-</span> يلتزم الفريق الثاني بدفع ما
          يترتب عليه من الأجور والرسوم والمخالفات والتعويضات المترتبة عليه
          المبينة في هذا العقد وفي الفواتير المحددة وفقاً للخط المعمول به
          والمُعتمد من قبل المرخص له.
        </p>
        <p>
          <span class="clause-letter">ح-</span> يلتزم الفريق الثاني بإشعار أو
          إرسال عن طريق البريد الإلكتروني في حال فقدان أو سرقة بيانات للمشترك
          الشخصية والخصوصية من أجل تمكين المرخص له من اتخاذ التدابير اللازمة
          والمحددة من الفريق الأول.
        </p>
        <p>
          <span class="clause-letter">خ-</span> يلتزم الفريق الثاني باستخدام
          الخدمة من الأجهزة المرخصة والمعتمدة من قبل الفريق الأول المرخص له
          والهيئة الناظمة للاتصالات والبريد ويلتزم بعدم استخدام أي أجهزة غير
          نظامية أو معدلة قد تؤثر على جودة الخدمة أو سلامة الشبكة، ويتحمل الفريق
          الثاني كامل المسؤولية عن أي أضرار فنية أو قانونية ناتجة عن مخالفة ذلك.
        </p>
        <p>
          <span class="clause-letter">د-</span> يلتزم الفريق الثاني بسداد جميع
          الضرائب و الرسوم والبدلات الحكومية المستحقة عن الخدمة المقدّمة من
          الطرف الأول وفقًا للقوانين والأنظمة النافذة، والتي يقوم الطرف الأول
          بتحصيلها نيابةً عن الجهات الحكومية المختصة، ولا يحق لـ الفريق الثاني
          الاعتراض أو الامتناع عن السداد بحجة عدم علمه بهذه الرسوم.
        </p>
      </div>

      <div class="article">
        <p class="article-title">المادة (٥) - مدة العقد وسريانه:</p>
        <p>
          <span class="clause-letter">أ-</span> إن مدة هذا العقد للاشتراك
          <span class="fill">{{
            account.profile.expiration_value +
              " " +
              account.profile.expiration_unit
          }}</span>
          وتبدأ هذه الفترة من تاريخ العقد أو من تاريخ إيصال الخدمة للعميل أيهما
          أسبق.
        </p>
        <p>
          <span class="clause-letter">ب-</span> يجدد العقد تلقائياً لمدة مماثلة
          ما لم يقم الفريق الثاني برغبته بإنهاء العقد قبل مهلة يحددها الطرف
          الأول مدتها لا تتجاوز 30 يوماً من تاريخ انتهاء العقد وعلى أن يتم تسديد
          جميع الالتزامات المالية المستحقة للمرخص له والهيئة الناظمة للاتصالات
          والبريد.
        </p>
        <p>
          <span class="clause-letter">ج-</span> في حال عدم التزام الفريق الثاني
          بإشعار الطرف الأول ضمن المهلة المحددة، يُعد العقد مجددًا تلقائيًا بذات
          الشروط والأحكام، وتستمر التزامات الطرفين سارية المفعول دون الحاجة إلى
          توقيع عقد جديد أو اتخاذ أي إجراء إضافي.
        </p>
      </div>

      <div class="article">
        <p class="article-title">مادة (٦) إلغاء العقد وفسخه:</p>
        <p>
          <span class="clause-letter">أ-</span> يحق للفريق الأول إلغاء وفسخ هذا
          العقد دون إشعار مسبق ولا إنذار مسبق في حال تخلف الفريق الثاني عن تسديد
          الالتزامات المالية المستحقة عليه بعد انتهاء المدة المنصوص عليها في
          البند (ب) من المادة (٥) أعلاه، أو في حال عدم التزام الفريق الثاني بأي
          من بنود هذا العقد.
        </p>

        <p>
          <span class="clause-letter">ب-</span> يحق للمرخص له فسخ العقد إذا تبين
          له أن المعلومات والبيانات المقدمة من الفريق الثاني غير صحيحة أو مضللة
          أو احتيالية، وعدم التزام الفريق الثاني بتسوية وضعه خلال ٥ أيام من
          تاريخ إشعار خطي من المرخص له.
        </p>
        <p>
          <span class="clause-letter">ج-</span> يحق للفريق الأول إنهاء العقد
          بإرادته المنفردة على أن يقوم بإخطار الفريق الثاني خطياً عبر التواصل
          المتفق عليه في العقد خلال مدة اقصاها 5 أيام.
        </p>
      </div>

      <div class="article">
        <p class="article-title">المادة (٧) المنازعات:</p>
        <p>
          <span class="clause-letter">أ-</span> إن أي نزاع حول هذا العقد يتم حله
          ودياً ما بين الفريقين ولمدة اقصاها 30 يوماً وفي حال عدم الوصول إلى حل
          ودي واستنفاد المدة المحددة في هذا العقد يتم حل النزاع عن طريق الأحكام
          والقوانين النافذة والمنصوص عليها في قانون الاتصالات رقم ١٨ لعام ٢٠١٠
          واللائحة التنفيذية الصادرة عن الهيئة الناظمة للاتصالات والبريد
          والقوانين المدنية والجزائية المعمول بها في الجمهورية العربية السورية.
        </p>
        <p>
          <span class="clause-letter">ب-</span> يتحمل الفريق الثاني كافة
          المصاريف والأعباء المالية والقضائية المترتبة على أي خرق لبنود هذا
          العقد أو الدخول في المادة (٤) الفقرة (ب) ويحق للفريق الأول المرخص له
          بالرجوع بكافة المصاريف والأتعاب القضائية والنفقات وأتعاب المحامين
          والغرامات غير المحدودة بحكم الصادرة بها عن المحاكم على الفريق الثاني.
        </p>
      </div>
    </div>
    <div class="page">
      <div class="article">
        <p>
          <span class="article-title">مادة (٨) الالتزامات المالية:</span> يلتزم
          الفريق الثاني بدفع ما يترتب عليه مالياً تجاه الفريق الأول والهيئة
          الناظمة للاتصالات أو أي جهة أخرى وإيفاء غرامات مالية ومخالفات مالية عن
          جراء أي مخالف لبنود العقد.
        </p>
      </div>

      <div class="article">
        <p>
          <span class="article-title">مادة (٩):</span> حرر هذا العقد على ثلاث
          نسخ واحتفظ كل فريق بنسخته والنسخة الثالثة للهيئة الناظمة للإتصالات
          والبريد.
        </p>
      </div>

      <div class="contract-date">
        في
        <span class="fill date">{{ get_current_date() }}</span>
      </div>

      <div class="signatures">
        <div class="sig-block">
          <div class="sig-title">ممثل الفريق الأول المفوض</div>
          <div class="sig-line">التوقيع</div>
        </div>
        <div class="sig-block">
          <div class="sig-title">الفريق الثاني</div>
          <div class="sig-line">التوقيع</div>
        </div>
      </div>
    </div>
    <div
      class="page"
      v-if="account.nid_image_back_url || account.nid_image_front_url"
    >
      <div class="signatures">
        <div class="sig-block">
          <span class="article-title">صورة الهوية وجه اول</span>
          <img
            v-if="account.nid_image_front_url"
            :src="account.nid_image_front_url"
            :alt="account.username"
            style="max-height: 30rem;"
            class="mb-4"
          />
        </div>
      </div>
      <div class="signatures">
        <div class="sig-block">
          <span class="article-title">صورة الهوية وجه ثان</span>
          <img
            v-if="account.nid_image_back_url"
            :src="account.nid_image_back_url"
            :alt="account.username"
            style="max-height: 30rem;"
            class="mb-4"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="a4page" v-else>
    <div class="doc-title">عقد اشتراك</div>

    <div class="parties">
      <div class="party-row">
        <span class="party-label">الفريق الأول:</span>
        <span class="fill wide">{{ setting.contract.company_name }}</span>
      </div>
      <div class="party-row">
        رقم قرار الترخيص:
        <span class="fill">{{ setting.contract.license_number }}</span>
        تاريخ القرار:
        <span class="fill">{{ setting.contract.license_date }}</span>
      </div>
      <div class="party-row">
        تخصص الشركة:
        <span class="fill">{{ setting.contract.company_speciality }}</span>
      </div>

      <div class="party-row">
        <span class="party-label">الفريق الثاني: الاسم:</span>
        <span class="fill">{{ account.first_name }}</span>
        بن
        <span class="fill">{{ account.father_name }}</span>
        ووالدته
        <span class="fill">{{ account.mother_name }}</span>
      </div>
      <div class="party-row">
        سنة المواليد:
        <span class="fill date"> </span>/<span class="fill date"> </span>/<span
          class="fill date"
        >
        </span>
        القيد:
        <span class="fill"> </span>
        بموجب الهوية الشخصية:
        <span class="fill">{{ account.national_id }}</span>
      </div>

      <div class="party-row">
        صادرة عن أمانة سجل:
        <span class="fill"> </span>
        تاريخ المنح:
        <span class="fill date"> </span>/<span class="fill date"> </span>/<span
          class="fill date"
        >
        </span>
      </div>

      <div class="party-row">
        العنوان: المحافظة
        <span class="fill">{{ account.state }}</span>
        المدينة
        <span class="fill">{{ account.city }}</span>
        مكان السكن:
        <span class="fill wide">{{ account.address }}</span>
      </div>

      <div class="party-row">
        عنوان البريد الإلكتروني:
        <span class="fill wide">{{ account.email }}</span>
        رقم التواصل:
        <span class="fill">{{ account.phone }}</span>
      </div>
      <div class="party-row">
        اسم المستخدم:
        <span class="fill">{{ account.username }}</span>
        كلمة المرور:
        <span class="fill">{{ account.password }}</span>
        عنوان IP:
        <span class="fill" v-if="account.private_ip">{{
          account.private_ip.ip_address
        }}</span>
      </div>
    </div>

    <div v-html="custom_contract_text"></div>
    <div
      class="page"
      v-if="account.nid_image_back_url || account.nid_image_front_url"
    >
      <div class="signatures">
        <div class="sig-block">
          <span class="article-title">صورة الهوية وجه اول</span>
          <img
            v-if="account.nid_image_front_url"
            :src="account.nid_image_front_url"
            :alt="account.username"
            style="max-height: 30rem;"
            class="mb-4"
          />
        </div>
      </div>
      <div class="signatures">
        <div class="sig-block">
          <span class="article-title">صورة الهوية وجه ثان</span>
          <img
            v-if="account.nid_image_back_url"
            :src="account.nid_image_back_url"
            :alt="account.username"
            style="max-height: 30rem;"
            class="mb-4"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { now } from "moment";
import { mapGetters } from "vuex";
export default {
  name: "AccountContract",
  data() {
    return {
      setting: {
        contract: {
          company_name: "",
          company_speciality: "",
          license_number: "",
          license_date: "",
          custom_contract_text: false,
          contract_text: "",
        },
      },
    };
  },
  computed: {
    ...mapGetters(["settings"]),
  },
  props: {
    account: {
      type: Object,
      required: true,
    },
    custom_contract_text: {
      type: String,
      required: false,
    },
  },
  created() {
    this.setting = this.settings;
  },
  methods: {
    get_current_date() {
      return moment().format("YYYY-MM-DD");
    },
    async fetchContract() {
      try {
        this.loading = true;
        const response = await axios.get("/settings/contract");
        if (response.status == 200) {
          this.setting.contract.contract_text = response.data.data;
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
  },
};
</script>
